import type { Subscription } from '@/types/models.types';
import { PackageProducts } from '../constants/constants';

/**
 * Searches within a provided array of subscriptions to determine
 * if there is an active subscription to the mentioned packages.
 * @param subscriptions
 * @returns `true` : `false`
 */
export function hasActivePackageSubscription(subscriptions: Subscription[]): boolean {
  if (!subscriptions || subscriptions.length === 0) {
    return false;
  }

  const result = subscriptions.some((subscription) => {
    // @ts-expect-error - product.id is a string, but PackageProducts consists of particular strings
    return subscription.active && PackageProducts.includes(subscription.product.id);
  });

  return result;
}
